<pp-user-profile-form
  [class.inactive]="isSecondStep()"
  [user]="user()"
  [org]="org()"
  [readonlyRights]="readonlyRights()"
  (unsavedChanges)="handleUnsavedChanges($event)"
  (submitForm)="changeProfile($event)"
  (close)="closeDialog.emit(false)" />

@if (isSecondStep()) {
  <pp-email-phone-verification
    [user]="changedUser()"
    (back)="isSecondStep.set(false)"
    (submit)="verifyEmailPhone($event)"
    (resendEmailCode)="resendEmailCode()"
    (resendPhoneCode)="resendPhoneCode()" />
}
